import React from "react";
import { Navigate } from "react-router-dom";
import useAccessProfile from "../../hooks/useAccessProfile";
import {
  isActiveUser,
  hasRole,
  hasPermission,
} from "../../utils/accessControl";

export default function ProtectedAccessRoute({
  children,
  requireRole,
  requirePermission,
  fallbackPath = "/",
}) {
  const { profile, loading } = useAccessProfile();

  if (loading) {
    return <div style={{ padding: 16 }}>Loading access profile...</div>;
  }

  if (!isActiveUser(profile)) {
    return (
      <div style={{ padding: 16 }}>
        Your account is currently inactive. Please contact an administrator.
      </div>
    );
  }

  if (requireRole && !hasRole(profile, requireRole)) {
    return <Navigate to={fallbackPath} replace />;
  }

  if (requirePermission && !hasPermission(profile, requirePermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}